import { render, staticRenderFns } from "./QuadroHorarios.vue?vue&type=template&id=273f42a3&"
import script from "./QuadroHorarios.vue?vue&type=script&lang=js&"
export * from "./QuadroHorarios.vue?vue&type=script&lang=js&"
import style0 from "./QuadroHorarios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports